<template>
  <v-dialog
    v-model="dialog"
    max-width="500px"
    transition="dialog-transition"
    content-class="buyPeachSuccessful"
  >
    <v-card>
      <v-card-title class="success white--text" style="font-size: 25px">
        <v-icon left large color="white">fa-check-circle</v-icon>
        購買成功
      </v-card-title>
      <v-card-text class="pa-5 text-center" @click="dialog = false">
        恭喜您！您的桃子增加了 
        <div class="value">
          <div class="peach"></div>
          {{ value }}
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      value: 0
    }
  },
  methods: {
    setValue(value) {
      try {
        if(/^\d+$/.test(atob(value))) {
            this.value = atob(value)
            this.dialog = true
        }
      }
      catch {}
    }
  }
}
</script>

<style lang="scss" scoped>
.buyPeachSuccessful {
  position: relative;
  .v-btn {
    z-index: 1;
  }
  .value {
    margin-top: 10px;
    text-align: center;
    font-weight: 500;
    .peach {
      width: 25px;
      height: 25px;
      margin-right: 0;
    }
    color: $main;
    font-size: 30px;
  }
}
</style>